import styles from "./TransportAgreement.module.scss";

const AdditionalTourConditions = () => {
  return (
    <div>
      <h1 className={styles.Title}>
        Terms and Conditions for Organized Tour Travel
      </h1>
      <h2 style={{ marginBottom: 20 }}>Travel</h2>
      <div className={styles.Section}>
        <div>
          <strong>Application</strong>
          <ul>
            <li>
              When applying, you need to complete the application form on our
              designated website and pay the application fee. (Your application
              becomes official once both are completed.) Note: The application
              fee will be treated as part or all of the &quot;travel fee,&quot;
              &quot;cancellation fee,&quot; or &quot;penalty fee.&quot;
            </li>
            <li>
              If you have any physical disabilities, are pregnant, or require
              special consideration, please inform us. We will accommodate
              within the possible range. Please note that any costs incurred for
              special measures taken based on your request will be borne by you.
            </li>
            <li>
              Applicants under 15 years old at the time of application must be
              accompanied by a guardian.
            </li>
          </ul>
          <br />
          <strong>Travel Fee</strong>
          <p>
            The child fare applies to children who are 3 years old or older but
            under 12 years old at the start of the trip.
          </p>

          <br />
          <strong>Additional Fees</strong>
          <p>Additional fees refer to charges added due to:</p>

          <ol>
            <li>Choice of airline company</li>
            <li>Choice of flight</li>
            <li>Choice of aircraft class</li>
            <li>Selection of designated hotels or inns</li>
            <li>Single room additional fee</li>
            <li>Accommodation fees due to extended stay</li>
            <li>Choice between weekdays and days before holidays</li>
            <li>Selection of departure and return days of the week</li>
          </ol>

          <br />
          <strong>Standard Travel Fee</strong>
          <p>
            The travel fee that serves as the basis for calculating the
            application fee, cancellation fee, and change compensation fee
            includes the additional travel fees.
          </p>
          <br />
          <strong>Changes to Travel Contract Contents and Fees</strong>
          <ul>
            <li>
              We may change the contract contents if unavoidable circumstances
              beyond our control occur, such as natural disasters, wars, riots,
              suspension of services by transportation or accommodation
              facilities, orders from public authorities, provision of
              transportation services not according to the original operation
              plan, or other reasons we cannot influence.
            </li>
            <li>
              If there is a significant increase in the fares or fees of
              transportation facilities due to substantial changes in economic
              conditions that exceed the usual expected range, we may change the
              travel fee. In the case of an increase, we will inform you no
              later than 15 days before the start date of the trip.
            </li>
          </ul>

          <br />

          <strong>
            When Cancellation Fees Apply (Customer-Initiated Cancellation of
            Travel Contract)
          </strong>
          <p>
            You can cancel the travel contract by paying the specified
            cancellation fee.
            <br />
            The travel fee subject to the cancellation fee is the total amount
            of the displayed travel fee plus any additional fees.
          </p>
          <br />
          <strong>
            When Cancellation Fees Do Not Apply (Customer-Initiated Cancellation
            of Travel Contract)
          </strong>
          <p>
            No cancellation fee will be charged in the following cases (partial
            examples):
          </p>
          <ol>
            <li>
              When significant changes as exemplified below are made to the
              travel contract contents:
              <ul>
                <li>Change of the start or end date of the trip</li>
                <li>
                  Change of sightseeing spots, tourist facilities to be entered,
                  or other travel destinations
                </li>
                <li>
                  Change of the type or company name of the transportation
                  facility
                </li>
                <li>
                  Change to a lower class or facilities of the transportation
                  facility
                </li>
              </ul>
            </li>
            <li>When the travel fee has been increased.</li>
            <li>
              When we do not deliver the finalized itinerary by the specified
              date.
            </li>
            <li>
              When it becomes impossible to carry out the original travel
              schedule due to reasons attributable to us.
            </li>
          </ol>
        </div>

        <div>
          <strong>Cancellation of Travel Contract by Our Company</strong>

          <p>
            We may cancel the travel contract in the following cases (partial
            examples):
          </p>
          <ul>
            <li> When the travel fee is not paid by the due date.</li>
            <li>Non-compliance with application conditions.</li>
            <li>
              When it becomes impossible to smoothly implement the trip due to
              illness, hindrance to group activities, or other reasons.
            </li>
          </ul>
          <br />

          <strong>Our Responsibility</strong>
          <ul>
            <li>
              If we or our arranging agents cause damage to you, we will
              compensate for the damage. The compensation limit related to
              luggage is 150,000 yen (however, this does not apply if we have
              intentional or gross negligence).
            </li>
            <li>
              We are not responsible in principle in the following cases: when
              you suffer damage due to reasons beyond our or our arranging
              agents&apos; control, such as natural disasters, wars, riots,
              suspension of travel services by transportation or accommodation
              facilities, orders from public authorities, etc.
            </li>
          </ul>
          <br />

          <strong>Special Compensation</strong>

          <ul>
            <li>
              During participation in this trip, if you suffer certain damage to
              life, body, or luggage due to sudden and accidental external
              accidents, we will pay compensation according to the Special
              Compensation Regulations of the Travel Agency Agreement:
              <ul>
                <li>
                  <b>Death Compensation:</b> 15 million yen for domestic travel
                </li>
                <li>
                  <b>Hospitalization Consolation Money:</b> 20,000 yen to
                  200,000 yen for domestic travel, depending on the number of
                  hospitalization days
                </li>
                <li>
                  <b>Outpatient Consolation Money:</b> 10,000 yen to 50,000 yen
                  for domestic travel, depending on the number of outpatient
                  days
                </li>
                <li>
                  <b>Compensation for Damage to Personal Belongings:</b> Up to
                  150,000 yen (however, the compensation limit for one item or
                  one pair is 100,000 yen)
                </li>
              </ul>
            </li>
          </ul>
          <i style={{ fontSize: 12, marginTop: 10, display: "block" }}>
            Note: For days specified in the itinerary as days when no travel
            services are provided by our arrangements, we will not consider such
            days as &quot;during trip participation&quot; only if it is clearly
            stated that compensation will not be paid for damages suffered on
            those days.
          </i>
          <br />

          <strong>Itinerary Guarantee</strong>
          <ul>
            <li>
              If changes listed in the table below occur in the travel
              itinerary, we will pay a change compensation fee calculated by
              multiplying the travel fee by the rate specified in the table,
              according to the provisions of the Travel Agency Agreement
              (Organized Tour Travel Contract Section).
            </li>
            <li>
              However, the amount of change compensation fee paid for one travel
              contract is limited to 15% of the travel fee. Also, if the amount
              of change compensation fee for one travel contract is less than
              1,000 yen, we will not pay the change compensation fee.
            </li>
            <li>
              The travel fee that serves as the basis for calculating the change
              compensation fee is the total amount of the displayed travel fee
              plus the additional fees.
            </li>
          </ul>
          <br />
          <strong>Handling of Personal Information</strong>
          <ul>
            <li>
              We will use the personal information provided in the application
              form submitted at the time of travel application for contacting
              you and to the extent necessary for arranging and receiving the
              services provided by transportation and accommodation facilities
              in the trip you applied for.
            </li>
          </ul>
          <br />
          <i>
            Note: Additionally, we may use the personal information of travelers
            for:
          </i>
          <ol>
            <li>
              Providing information on products, services, and campaigns of our
              company and affiliated companies
            </li>
            <li>
              Requesting opinions and impressions after participation in travel
            </li>
            <li>Requesting participation in questionnaires</li>
            <li>Providing special services</li>
            <li>Creating statistical materials</li>
            <li>
              We will use the minimum necessary range of personal data we hold,
              such as your name, address, telephone number, or email address,
              which is necessary for contacting you. We may use this for
              providing information on business guides, event contents, or for
              shipping products you have purchased (specifically stating the
              purpose of use).
            </li>
          </ol>

          <i>Note: Under no circumstances will we re-implement the trip.</i>
          <br />
          <br />
        </div>
      </div>
    </div>
  );
};

export default AdditionalTourConditions;
